const getEntries = (object: { [key: string]: any }): [string, any][] => (Object.entries(object));

export default getEntries;
